import styled from 'styled-components/macro';

export const OlvLockContainer = styled.div<{ $isPermanent: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 32px;
  text-align: center;
  background: ${({ $isPermanent, theme }) =>
    $isPermanent ? theme.color.red[100] : theme.color.yellow[100]};
`;

export const OlvLockIcon = styled.img<{ $isPermanent: boolean }>`
  width: 48px;
  height: 48px;
  margin-bottom: 16px;
  opacity: ${({ $isPermanent }) => ($isPermanent ? 0.8 : 0.6)};
`;

export const OlvLockMessage = styled.h3`
  color: ${({ theme }) => theme.color.gray[900]};
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 8px 0;
`;

export const OlvLockSubMessage = styled.p`
  color: ${({ theme }) => theme.color.gray[600]};
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
  max-width: 320px;
`;
